import { Grid, Box, Skeleton } from '@mui/joy'
import { useStore } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Alert } from '~/shared/ui/Alerts'
import { Dropzone } from '~/shared/ui/Dropzone'
import { Container, ContainerTitle } from '~/shared/ui/Layout'
import {
  $importId,
  $isTransactionsError,
  $totalAmount,
  getTotalAmountFx,
  massImport,
  massImportFx,
  massImportSave,
  massImportSaveFx,
} from './model'
import { Form, formModel } from './ui/Form'
import { List } from './ui/List'

export function BulkCreateTransactions() {
  const { t } = useTranslation()
  const masImportPending = useStore(massImportFx.pending)
  const totalAmountPending = useStore(getTotalAmountFx.pending)
  const isSubmitting = useStore(massImportSaveFx.pending)
  const isTransactionsError = useStore($isTransactionsError)

  const importId = useStore($importId)
  const totalAmount = useStore($totalAmount)

  const handleMassImport = (files: File[]) => {
    massImport(files[0])
  }

  const handleMassImportSave = (formValues: formModel.FormValues) => {
    if (!importId) {
      snackbarEnqueued({
        messageI18n: 'alert.upload file with transactions',
        variant: 'error',
      })
      return
    }
    if (isTransactionsError) {
      snackbarEnqueued({
        messageI18n:
          'alert.rows with errors found, correct source file and reupload full list',
        variant: 'error',
      })
      return
    }
    massImportSave(formValues)
  }

  return (
    <>
      <Form onSuccess={handleMassImportSave} isSubmitting={isSubmitting}>
        <Container>
          <Grid xs={12}>
            <ContainerTitle>{t('form.file')}</ContainerTitle>
            <Dropzone
              isSubmitting={masImportPending}
              accept={{
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                  [],
                'application/vnd.ms-excel': [],
              }}
              onDropAccepted={handleMassImport}
              inputProps={{ name: 'massImport' }}
              maxFiles={1}
              canDelete
              canCreate
            />
          </Grid>
        </Container>

        {!masImportPending && isTransactionsError && (
          <Container>
            <Grid xs={12}>
              <Alert variant='error'>
                {t(
                  'alert.rows with errors found, correct source file and reupload full list',
                )}
              </Alert>
            </Grid>
          </Container>
        )}
        {!masImportPending && !importId && (
          <Container>
            <Grid xs={12}>
              <Alert variant='info'>
                {t('alert.upload file to preview transactions')}
              </Alert>
            </Grid>
          </Container>
        )}

        <Container>
          <List importId={importId} />
        </Container>

        <Container>
          <Box
            sx={{
              display: 'flex',
              fontWeight: 600,
            }}
          >
            {t('total amount')}{' '}
            <>
              {totalAmountPending ? (
                <Skeleton
                  sx={{
                    width: '100px',
                    marginLeft: '8px',
                    height: '24px',
                    position: 'relative',
                    borderRadius: '12px',
                  }}
                />
              ) : (
                Number(totalAmount || 0).toLocaleString()
              )}
            </>
          </Box>
        </Container>
      </Form>
    </>
  )
}
